// extracted by mini-css-extract-plugin
module.exports = {"mainNavigation":"Navigation_mainNavigation__1A2g9","active":"Navigation_active__sU4lX","reviewScoreBox":"Navigation_reviewScoreBox__UaQ8K"};